import Translation from '@/client/components/Translation';

type Props = {
  name: string;
  translations: Record<string, string>;
};

const OptionTitle: FC<Props> = ({ name, translations }) => {
  const isDefault = name === 'default';
  const translationKey = isDefault ? 'casino.default' : `cashier.${name}`;
  if (!translations[translationKey]) {
    return name;
  }
  return (
    <>
      <Translation id={translationKey} translations={translations} />
      {!isDefault && ` (${name})`}
    </>
  );
};

export default OptionTitle;
